var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 40,
    viewBox: "0 0 34 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M23.6295 8.13229C22.7266 8.13142 21.8609 7.77234 21.2224 7.13387C20.5839 6.49541 20.2249 5.6297 20.224 4.72677V3.06895e-07H5.00815C4.42437 -0.000216631 3.84625 0.11458 3.30685 0.337833C2.76744 0.561085 2.27732 0.888422 1.86445 1.30114C1.45158 1.71386 1.12406 2.20387 0.900611 2.74319C0.677158 3.28251 0.562134 3.86058 0.562134 4.44436V31.236C0.563885 32.4139 1.03313 33.5429 1.86677 34.3749C2.70042 35.207 3.83029 35.6742 5.00815 35.6737H23.2744C23.8581 35.6737 24.436 35.5588 24.9752 35.3354C25.5144 35.1121 26.0044 34.7847 26.4171 34.372C26.8298 33.9593 27.1571 33.4694 27.3805 32.9302C27.6038 32.391 27.7188 31.813 27.7188 31.2294V8.13229H23.6295Z",
    fill: "#00C650"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7189 8.13229H23.6296C22.7267 8.13142 21.861 7.77234 21.2225 7.13387C20.5841 6.49541 20.225 5.6297 20.2241 4.72677V0L27.7189 8.13229Z",
    fill: "#00C650"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9426 28.1758H10.2914C8.82655 28.1758 7.63904 29.3633 7.63904 30.8282V36.9852C7.63904 38.4501 8.82655 39.6376 10.2914 39.6376H30.9426C32.4075 39.6376 33.595 38.4501 33.595 36.9852V30.8282C33.595 29.3633 32.4075 28.1758 30.9426 28.1758Z",
    fill: "#00C650"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.346 35.2395V36.4402H11.1024V35.2395H12.346Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7219 31.4739L18.5345 36.4401H17.048L16.2553 33.1172L15.4543 36.4401H13.9679L12.7804 31.4739H14.0868L14.7259 35.071L15.598 31.4739H16.9192L17.7913 35.071L18.437 31.4739H19.7219Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4314 35.5334H21.5684L21.2595 36.4401H19.9961L21.8128 31.5085H23.1968L25.0135 36.4401H23.7352L23.4314 35.5334ZM23.1209 34.6201L22.5032 32.7951L21.8789 34.6201H23.1209Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4092 31.4739L27.6247 35.2114L28.8403 31.4739H30.1252L28.3977 36.4401H26.8452L25.1243 31.4739H26.4092Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4189 21.7875H18.6021V14.4777C18.6021 14.2328 18.5049 13.998 18.3317 13.8248C18.1586 13.6517 17.9238 13.5544 17.6789 13.5544H13.0545C12.8097 13.5544 12.5749 13.6517 12.4017 13.8248C12.2286 13.998 12.1313 14.2328 12.1313 14.4777V21.7875H10.3229V13.86C10.3229 13.2984 10.5459 12.7599 10.943 12.3628C11.3401 11.9657 11.8786 11.7427 12.4402 11.7427H18.2884C18.8499 11.7427 19.3884 11.9657 19.7855 12.3628C20.1826 12.7599 20.4057 13.2984 20.4057 13.86L20.4189 21.7875Z",
    fill: "#00C650"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2752 23.931C19.4591 23.931 20.4189 22.9712 20.4189 21.7873C20.4189 20.6033 19.4591 19.6436 18.2752 19.6436C17.0912 19.6436 16.1315 20.6033 16.1315 21.7873C16.1315 22.9712 17.0912 23.931 18.2752 23.931Z",
    fill: "#00C650"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0074 23.931C11.1913 23.931 12.1511 22.9712 12.1511 21.7873C12.1511 20.6033 11.1913 19.6436 10.0074 19.6436C8.82342 19.6436 7.86365 20.6033 7.86365 21.7873C7.86365 22.9712 8.82342 23.931 10.0074 23.931Z",
    fill: "#00C650"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWav);
export default __webpack_public_path__ + "static/media/wav.05e51d91d65d061e33a976873ed83f93.svg";
export { ForwardRef as ReactComponent };